import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';

/** @category Instruments */
export function useVaults(profileId?: string) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  const vaults = useQuery(tokenizedApi.treasury.vaultsQuery(profileId));
  return vaults?.data?.vaults;
}
